function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  padding: 1rem;\n  border-radius: ",
        ";\n  border: 1px solid;\n  display: flex;\n  gap: 0.75rem;\n  \n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  flex-shrink: 0;\n  width: 1.25rem;\n  height: 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  margin: 0 0 0.25rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.5rem;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  opacity: 0.9;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  width: 1.5rem;\n  height: 1.5rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: currentColor;\n  opacity: 0.7;\n  cursor: pointer;\n  border-radius: ",
        ";\n  transition: opacity ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  &:hover {\n    opacity: 1;\n  }\n  \n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px currentColor;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
var AlertContainer = styled.div(_templateObject(), function(props) {
    var _props_theme_radius, _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_radius = _props_theme.radius) === null || _props_theme_radius === void 0 ? void 0 : _props_theme_radius.md) || '0.5rem';
}, function(props) {
    var theme = props.theme;
    switch(props.$variant){
        case 'info':
            return "\n          background-color: rgba(59, 130, 246, 0.1);\n          border-color: rgba(59, 130, 246, 0.3);\n          color: ".concat((theme === null || theme === void 0 ? void 0 : theme.info) || '#2563eb', ";\n          \n          .dark & {\n            background-color: rgba(59, 130, 246, 0.2);\n            border-color: rgba(59, 130, 246, 0.4);\n            color: ").concat((theme === null || theme === void 0 ? void 0 : theme.info) || '#60a5fa', ";\n          }\n        ");
        case 'success':
            return "\n          background-color: rgba(16, 185, 129, 0.1);\n          border-color: rgba(16, 185, 129, 0.3);\n          color: ".concat((theme === null || theme === void 0 ? void 0 : theme.success) || '#059669', ";\n          \n          .dark & {\n            background-color: rgba(16, 185, 129, 0.2);\n            border-color: rgba(16, 185, 129, 0.4);\n            color: ").concat((theme === null || theme === void 0 ? void 0 : theme.success) || '#34d399', ";\n          }\n        ");
        case 'warning':
            return "\n          background-color: rgba(245, 158, 11, 0.1);\n          border-color: rgba(245, 158, 11, 0.3);\n          color: ".concat((theme === null || theme === void 0 ? void 0 : theme.warning) || '#d97706', ";\n          \n          .dark & {\n            background-color: rgba(245, 158, 11, 0.2);\n            border-color: rgba(245, 158, 11, 0.4);\n            color: ").concat((theme === null || theme === void 0 ? void 0 : theme.warning) || '#fbbf24', ";\n          }\n        ");
        case 'error':
            return "\n          background-color: rgba(239, 68, 68, 0.1);\n          border-color: rgba(239, 68, 68, 0.3);\n          color: ".concat((theme === null || theme === void 0 ? void 0 : theme.error) || '#dc2626', ";\n          \n          .dark & {\n            background-color: rgba(239, 68, 68, 0.2);\n            border-color: rgba(239, 68, 68, 0.4);\n            color: ").concat((theme === null || theme === void 0 ? void 0 : theme.error) || '#f87171', ";\n          }\n        ");
    }
});
var IconWrapper = styled.div(_templateObject1());
var ContentWrapper = styled.div(_templateObject2());
var AlertTitle = styled.h4(_templateObject3());
var AlertDescription = styled.div(_templateObject4());
var CloseButton = styled.button(_templateObject5(), function(props) {
    var _props_theme_radius, _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_radius = _props_theme.radius) === null || _props_theme_radius === void 0 ? void 0 : _props_theme_radius.sm) || '0.25rem';
}, function(props) {
    var _props_theme_transition, _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_transition = _props_theme.transition) === null || _props_theme_transition === void 0 ? void 0 : _props_theme_transition.fast) || '150ms ease';
});
var defaultIcons = {
    info: /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 20 20",
        fill: "currentColor",
        width: "20",
        height: "20"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
        clipRule: "evenodd"
    })),
    success: /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 20 20",
        fill: "currentColor",
        width: "20",
        height: "20"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    })),
    warning: /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 20 20",
        fill: "currentColor",
        width: "20",
        height: "20"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
        clipRule: "evenodd"
    })),
    error: /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 20 20",
        fill: "currentColor",
        width: "20",
        height: "20"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
        clipRule: "evenodd"
    }))
};
/**
 * Alert component for displaying important messages
 * 
 * @example
 * ```tsx
 * <Alert variant="info">
 *   This is an informational alert
 * </Alert>
 * 
 * <Alert variant="success" title="Success!" onClose={() => console.log('closed')}>
 *   Your action was completed successfully
 * </Alert>
 * ```
 */ export var Alert = function(param) {
    var children = param.children, _param_variant = param.variant, variant = _param_variant === void 0 ? 'info' : _param_variant, title = param.title, onClose = param.onClose, className = param.className, icon = param.icon;
    var defaultIcon = defaultIcons[variant];
    return /*#__PURE__*/ React.createElement(AlertContainer, {
        $variant: variant,
        className: className,
        role: "alert"
    }, icon !== null && /*#__PURE__*/ React.createElement(IconWrapper, null, icon || defaultIcon), /*#__PURE__*/ React.createElement(ContentWrapper, null, title && /*#__PURE__*/ React.createElement(AlertTitle, null, title), /*#__PURE__*/ React.createElement(AlertDescription, null, children)), onClose && /*#__PURE__*/ React.createElement(CloseButton, {
        onClick: onClose,
        "aria-label": "Close alert"
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M11 3L3 11M3 3l8 8"
    }))));
};
export default Alert;
